export default {
      id: "retirement-income-usage",
      viewBox: "0 0 100 101",
      url: __webpack_public_path__ + "sprite.svg#retirement-income",
      toString: function () {
        return this.url;
      }
    }